import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { Layers } from '@helpers/layers';
import { Device, from } from '@helpers/media';
import scrollbars from '@helpers/scrollbars';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import BackgroundStyles from '@stories/Components/Misc/Modal/Background/Background.styles';
import { m } from 'framer-motion';
import styled, { css } from 'styled-components';
import CtaBlockStyles from '../CtaBlock/CtaBlock.styles';
import GroupLinkStyles from '../GroupLink/GroupLink.styles';
import NavigationContactBlockStyles from '../NavigationContactBlock/NavigationContactBlock.styles';
import NavigationImageStyles from '../NavigationImage/NavigationImage.styles';
const Container = styled(m.div) `
  position: fixed;
  z-index: ${Layers.Navigation};
  top: calc(var(--headerHeight) + var(--announcementBarHeight));
  right: 0;
  height: calc(100vh - var(--headerHeight) - var(--announcementBarHeight));
  height: calc(100dvh - var(--headerHeight) - var(--announcementBarHeight));
  width: 100%;
  background-color: ${brand.primary.white};
  display: grid;
  grid-template-rows: 1fr min-content;

  ${NavigationContactBlockStyles.NavigationContactInfo} {
    grid-row: 2 / span 1;
    padding: 32px var(--sitePadding);
  }

  @media ${from(Device.Tablet)} {
    max-width: 480px;
  }

  @media ${from(Device.DesktopSmall)} {
    display: none;
  }
`;
const Bg = styled(BackgroundStyles.Background) `
  position: fixed;
  z-index: ${Layers.Navigation - 1};
  top: var(--headerHeight);
  height: calc(100vh - var(--headerHeight));
  height: calc(100dvh - var(--headerHeight));
`;
const BackButton = styled.button `
  ${ButtonReset};
  ${transition('transform', 0.25)};
  ${fonts.poppins.extraBold};

  display: flex;
  width: 100%;
  gap: 12px;
  align-items: center;
  padding: 20px var(--sitePadding);
  font-size: 20px;
  color: ${brand.primary.black};
  background-color: ${brand.primary.stone};
  text-decoration: none;

  &:active {
    transform: translateY(1.5px);
  }

  svg {
    display: block;
  }

  ${ButtonStyles.Container} {
    --bgColourHover: var(--bgColour);
    --colourTextHover: var(--colourText);
  }

  ${ButtonStyles.IconWrapper} {
    --iconHeight: 20px;
  }
`;
const commonLevelStyles = css `
  ${scrollbars};

  grid-row: 1 / span 1;
  grid-column: 1 / span 1;
  display: flex;
  flex-direction: column;
  background-color: inherit;
  overflow: auto;
`;
const TopLevel = styled(m.nav) `
  ${commonLevelStyles};

  padding-top: 6px;
`;
const MenuList = styled(m.ul) `
  ${commonLevelStyles};
`;
const MenuItem = styled.li `
  border-bottom: 1px solid ${brand.grey.light};
  margin: 0 var(--sitePadding);

  &[data-column-title] {
    ${fonts.poppins.extraBold};

    font-size: 20px;
    color: ${brand.grey.g200};

    &:not([data-column-ft='true']) {
      margin-top: 24px;
    }
  }

  &:has(${BackButton}) {
    margin: 0;
  }

  &:has(${NavigationImageStyles.Container}),
  &:has(${GroupLinkStyles.GroupLinkBlock}),
  &:has(${CtaBlockStyles.Container}) {
    border-bottom: none;
  }

  &[data-column-title],
  &:has(${GroupLinkStyles.GroupLinkBlock}) {
    padding: 16px 0 8px;
  }

  &:has(${CtaBlockStyles.Container}) {
    margin-top: auto;
  }

  ${NavigationImageStyles.Container},
  ${CtaBlockStyles.Container} {
    margin-top: 48px;
  }

  ${GroupLinkStyles.Container} {
    padding: 8px 0;
  }
`;
const MenuLink = styled.a `
  ${ButtonReset};
  ${transition('transform', 0.25)};
  ${fonts.poppins.extraBold};

  display: flex;
  width: 100%;
  gap: 16px;
  justify-content: space-between;
  align-items: center;
  padding: 14px 0;
  font-size: 16px;
  color: ${brand.primary.black};
  text-decoration: none;

  &:active {
    transform: translateY(1.5px);
  }

  svg {
    display: block;
    width: 10px;
    transform: rotate(-90deg);
  }
`;
const MobileNavigationStyles = {
    BackButton,
    Bg,
    Container,
    MenuItem,
    MenuLink,
    MenuList,
    TopLevel,
};
export default MobileNavigationStyles;
